export default __webpack_public_path__ + "static/media/logo.a87c143a.png";